var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";
import styled, { ThemeProvider } from "styled-components";
import { BaseBox } from '../../shared/Element';
import { doconTheme } from "../../../theme/default";
import Tooltip from './Tooltip';
var Box = styled(BaseBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
function DoconTooltip(_a) {
    var id = _a.id, hideTooltip = _a.hideTooltip, children = _a.children, showOnlyOnOverflow = _a.showOnlyOnOverflow, _b = _a.dataTip, dataTip = _b === void 0 ? "" : _b, _c = _a.tooltipProps, tooltipProps = _c === void 0 ? {} : _c, props = __rest(_a, ["id", "hideTooltip", "children", "showOnlyOnOverflow", "dataTip", "tooltipProps"]);
    var tooltipRef = useRef(null);
    var _d = __read(useState(showOnlyOnOverflow ? undefined : dataTip), 2), tip = _d[0], setTip = _d[1];
    var _e = __read(useState(false), 2), isMount = _e[0], setIsMount = _e[1];
    useEffect(function () {
        setIsMount(true);
    }, []);
    useEffect(function () {
        var _a;
        var _b = ((_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.children[0]) || {}, offsetWidth = _b.offsetWidth, scrollWidth = _b.scrollWidth;
        if (showOnlyOnOverflow && offsetWidth !== scrollWidth) {
            setTip(dataTip || " ");
        }
    }, [tooltipRef]);
    useEffect(function () {
        if (isMount && tip) {
            ReactTooltip.rebuild();
        }
    }, [tip]);
    var Id = id || tooltipProps.title || tooltipProps.subTitle;
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(Box, __assign({ as: 'div', "data-for": Id, ref: tooltipRef, "data-tip": tip }, props), children),
        !hideTooltip && React.createElement(Tooltip, __assign({ id: Id }, tooltipProps))));
}
export default styled(DoconTooltip)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
